import Vue from 'src/views/base'
import Component from 'vue-class-component'
import Goback from 'src/views/page/ems/unit/goback'
import AppHeader from 'components/appHeader'
import { Store as ComStore } from 'src/store/modules/common'

@Component({
    name: 'app',
    props: {},
    components: {
        Goback,
        AppHeader
    }
})
export default class App extends Vue {
    @ComStore.state('environmentObject') environmentObject
    @ComStore.action('initEnvironmentObject') initEnvironmentObject
    first = 1
    firstTime = null

    // 初始化plus (app用)
    initPlus() {
        this.environmentObject.isApp = true
        this.initEnvironmentObject(this.environmentObject)
        this.envObject = this.environmentObject

        let that = this
        // 监听手机物理返回键
        plus.ui.getSelfWindow().addEventListener('back', function() {
            // 再按一次退出应用程序
            that.back()
        }, false)
    }

    // 返回监听处理
    back() {
        let that = this
        let path = that.$route.path
        if (path === '/login' || path === '/ems/home' || document.getElementById('navFooter')) {
            // 首次按键，提示再按一次退出应用
            if (that.first < 2) {
                that.firstTime = new Date().getTime()
                that.first++
                that.toast('再按一次退出应用', { time: 1000 })
                setTimeout(function () {
                    that.first = 1
                    that.firstTime = null
                }, 2000)
            } else {
                if (new Date().getTime() - that.firstTime < 2000) {
                    plus.runtime.quit()
                }
            }
        } else {
            that.$router.go(-1)
        }
    }

    mounted () {
        let that = this
        if (window.plus) {
            that.initPlus()
        } else {
            document.addEventListener('plusready', function() {
                that.initPlus()
            }, false)
        }
    }

    created () {
        let agent = navigator.userAgent.toLowerCase()
        let isAndroid = agent.indexOf('android') > -1 || agent.indexOf('adr') > -1
        let isIos = !!agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || !!agent.match(/\(i[^;]+;( u;)? cpu.+mac os x/)
        this.environmentObject.isWX = this.isWX()
        this.environmentObject.isAndroid = isAndroid
        this.environmentObject.isIos = isIos
        this.initEnvironmentObject(this.environmentObject)
        this.envObject = this.environmentObject
    }
}



// WEBPACK FOOTER //
// ./src/views/app/app.js